import { FunctionComponent } from 'react'
import { MagicSpinner } from 'react-spinners-kit'

const Loader: FunctionComponent = () => {
  return <MagicSpinner color='#ed1c24' size={70} loading />
}
export default Loader
